import i18n from "@/i18n";

export const channelsModalFields = [
    {
        key: "name",
        label: i18n.t("channels.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    }
];

export const channelGroupChannelsModalFields = [
    {
        key: "name",
        label: i18n.t("channels.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "width",
        label: i18n.t("common.width")
    },
    {
        key: "height",
        label: i18n.t("common.height")
    },
    {
        key: "actions",
        label: ""
    }
];
